/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface GitLabAvailableProject
 */
export interface GitLabAvailableProject {
    /**
     * 
     * @type {number}
     * @memberof GitLabAvailableProject
     */
    projectId: number;
    /**
     * 
     * @type {string}
     * @memberof GitLabAvailableProject
     */
    projectPath: string;
    /**
     * 
     * @type {string}
     * @memberof GitLabAvailableProject
     */
    name: string;
}

export function GitLabAvailableProjectFromJSON(json: any): GitLabAvailableProject {
    return {
        'projectId': json['projectId'],
        'projectPath': json['projectPath'],
        'name': json['name'],
    };
}

export function GitLabAvailableProjectToJSON(value?: GitLabAvailableProject): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'projectId': value.projectId,
        'projectPath': value.projectPath,
        'name': value.name,
    };
}


